const ACESSOS = {
	
	ADMINPAGES: 2,
	AVISOS: 3,
	CATEGORIAS: 4,
	CLAS: 5,
	STATUS: 6,
	LOCAIS: 7,
	TIPOATIVIDADES: 8	,
	MOTIVOATENDIMENTO: 9,
	TIPOATENDIMENTO: 10,
	PERFISACESSOS: 11,
	PESSOAS: 12,
	FICHAS: 13,
	CALENDARIO: 14,
	TEXTOS: 15,
	MINHASPUBLICACOES: 16,
	PREFERENCIAS: 17,
	PERFIL: 18,
	INICIADOS: 19,
	NOVOINICIADO: 20,
	VISUALIZARPROPRIOCLA: 21,
	VISUALIZARCLASPORCASA: 22,
	VISUALZIARTODOSCLAS: 23,
	CADASTRARNOVOEVENTO: 24,
	VISUALIZARPARTICIPANTESCLA: 25,
	VISUALIZARPARTICIPANTESPORCASA: 26,
	VISUALIZARTODOSPARTICIPANTES: 27,
	VISUALIZARDOACOESCLA: 28,
	VISUALIZARDOACOESPORCASA: 29,
	VISUALIZARTODASDOACOES: 30,
	APROVARATENDIMENTO: 31,
	CANCELARATENDIMENTO: 32,
	REENVIAREMAILATENDIMENTO: 33,
	ATIVARUSUARIO: 34,
	INATIVARUSUARIO: 35,
	CURSOS: 36
}

export default ACESSOS